import {FC, PropsWithChildren, useEffect, useState} from "react"
import {useLocation, useNavigate} from "react-router-dom"
import 'file-power-boundle'
import {getUserInfo} from '@/utils/common'
import {useUserInfoContext} from '@/store/userInfo'

type PropType = FC<PropsWithChildren<{}>>

const thiteList = ['/login', '/qrlogin']
const RouterEnter:PropType = ({children}) => {
  const [done, setDone] = useState(false)
  const { updateBaseInfo } = useUserInfoContext()
  const navigator = useNavigate()
  const location = useLocation()
  const { userInfo } = useUserInfoContext()

  useEffect(() => {
    if(userInfo) {
      // 更新用户基本信息
      // updateBaseInfo()
    }
    if(thiteList.includes(location.pathname) || userInfo) {
      setDone(true)
    } else {
      // 前往登录
      navigator('/login?f=' + location.pathname, {
        replace: true
      })
    }
  }, [navigator, location.pathname, updateBaseInfo])

  return done && children
}

export default RouterEnter
